import React from "react";
import CustomModal from "../../../Core/CommonV2/CustomModal";

interface ConfirmMoveModalProps {
  visible: boolean;
  targetName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmMoveModal: React.FC<ConfirmMoveModalProps> = ({
  visible,
  targetName,
  onCancel,
  onConfirm,
}) => {
  return (
    <CustomModal
      visible={visible}
      width="360px"
      onCancel={onCancel}
      body={
        <div className="min-h-[299px] py-[15px] px-[16px]">
          <div className="relative h-[20px]">
            <div className="text-primary-700 out-500-14 text-sm font-500 absolute left-0">
              Change who has access?
            </div>
            <div
              className="w-[20px] h-[20px] flex justify-center items-center absolute right-0 "
              onClick={onCancel}
            >
              <img
                className="w-[10px] h-[10px] cursor-pointer"
                src="/images/icons/cross.svg"
              />
            </div>
          </div>
          <div className="pb-[17px] pt-[17px]">
            <img
              src={"/images/v2/library/confirm-move.svg"}
              className="w-[141px] h-[108px]"
              alt="Penguin asking for confirmation!"
            />
          </div>
          <div className="text-gray-500 font-[Outfit] text-[14px] text-sm  text-left pb-[17px]">
            <span>
              {`  This item will be visible to anyone who has access to`}{" "}
            </span>
            <span className="text-black out-500-14 ">{`${targetName}`}. </span>
            <span>{`You can change who can see this item after moving it.`}</span>
          </div>
          <div className="flex justify-end items-center gap-[10px]">
            <button
              className="h-[30px] px-[10px] text-gray-500 out-500-14 rounded-[8px]"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              className="h-[30px] px-[10px] flex justify-center items-center text-white out-500-14 bg-primary-600 rounded-[8px]"
              onClick={onConfirm}
            >
              Move
            </button>
          </div>
        </div>
      }
    />
  );
};

export default ConfirmMoveModal;
